import React from 'react';
import { observer, inject } from 'mobx-react';
import Title from '@/components/Title';
import List from '@/components//List';
import styles from '../AppFirmware/AppFirmware.less';
import AddApp from '@/components/AppFile/AddApp';
import Loading from '../../components/Loading';

@inject('appFileStore')
@observer
class AppFile extends React.Component {
  constructor(props) {
    super(props);
    this.showAppModal = this.showAppModal.bind(this);
    this.hideAppModal = this.hideAppModal.bind(this);
  }
  componentDidMount() {
    this.props.appFileStore.loadAppList();
  }
  showAppModal() {
    this.props.appFileStore.toggleModal(true);
  }
  hideAppModal() {
    this.props.appFileStore.toggleModal(false);
  }
  render() {
    const { addAppLoading } = this.props.appFileStore;
    return (
      <div className={styles.appFirmware}>
        <Title
          titleText={'App列表'}
          btn={{
            text: '新增App',
            func: this.showAppModal,
            state: true
          }}
        />
        <div className={styles.listContainer}>
          {([...this.props.appFileStore.appListArr] || []).map(
            (item, index) => (
              <List
                key={index}
                BasicInfo={item}
                btnType={'fileBtn'}
                histroyList={item.file_list}
                unfold={false}
              />
            )
          )}
        </div>
        <AddApp
          appModal={this.props.appFileStore.appModal}
          hideAppModal={this.hideAppModal}
        />
        <Loading />
      </div>
    );
  }
}
export default AppFile;



// WEBPACK FOOTER //
// ./src/pages/AppFile/AppFile.js